import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Button } from '../../components/ui/button';
import API_BASE_URL from '../../Config'; // Ajustá la ruta si es diferente


export default function GastoAdmin() {
  const [descripcion, setDescripcion] = useState('');
  const [monto, setMonto] = useState('');
  const [tipo, setTipo] = useState('');
  const [gastos, setGastos] = useState([]);

  const fetchGastos = () => {
    axios.get(`${API_BASE_URL}/api/gastos`)
      .then(res => setGastos(res.data))
      .catch(err => console.error('Error al cargar gastos:', err));
  };

  useEffect(() => {
    fetchGastos();
  }, []);

  const handleRegistrar = () => {
    if (!descripcion || !monto || !tipo) {
      alert('Todos los campos son obligatorios');
      return;
    }

    axios.post(`${API_BASE_URL}/api/gastos`, {
      descripcion,
      monto,
      tipo
    }).then(() => {
      setDescripcion('');
      setMonto('');
      setTipo('');
      fetchGastos();
    }).catch(err => {
      console.error('Error al registrar gasto:', err);
    });
  };

  return (
    <div className="p-6 space-y-6">
      <h2 className="text-2xl font-bold">🧾 Registro de Gastos</h2>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <input
          type="text"
          placeholder="Descripción"
          value={descripcion}
          onChange={e => setDescripcion(e.target.value)}
          className="border px-4 py-2 rounded"
        />
        <input
          type="number"
          placeholder="Monto (Gs)"
          value={monto}
          onChange={e => setMonto(e.target.value)}
          className="border px-4 py-2 rounded"
        />
        <select
          value={tipo}
          onChange={e => setTipo(e.target.value)}
          className="border px-4 py-2 rounded"
        >
          <option value="">Seleccionar Tipo</option>
          <option value="Luz">Luz</option>
          <option value="Agua">Agua</option>
          <option value="Limpieza">Limpieza</option>
          <option value="Otro">Otro</option>
        </select>
      </div>

      <Button className="bg-blue-600 text-white" onClick={handleRegistrar}>Registrar Gasto</Button>

      <h3 className="text-xl font-semibold mt-6">📋 Lista de Gastos</h3>
      <table className="w-full table-auto border mt-2">
        <thead className="bg-gray-100">
          <tr>
            <th className="border p-2">ID</th>
            <th className="border p-2">Descripción</th>
            <th className="border p-2">Tipo</th>
            <th className="border p-2">Monto</th>
            <th className="border p-2">Fecha</th>
          </tr>
        </thead>
        <tbody>
          {gastos.map(gasto => (
            <tr key={gasto.id}>
              <td className="border p-2">{gasto.id}</td>
              <td className="border p-2">{gasto.descripcion}</td>
              <td className="border p-2">{gasto.tipo}</td>
              <td className="border p-2">{gasto.monto}</td>
              <td className="border p-2">{gasto.fecha}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
